/**
 * Parses the `tmpl_otherdetails` JSON string from the given templateDetails object,
 * and safely extracts relevant fields for AI report generation UI.
 *
 * @param {Object} templateDetails - The object containing template details.
 * @param {string} [templateDetails.tmpl_otherdetails] - JSON string containing additional details.
 * @returns {Object} An object with the following properties:
 *   - showAIReportGenerateBtn {boolean|null} — Indicates whether to show the AI report generate button.
 *   - buttonCaption {string|null} — Caption text for the button.
 *   - alertMessage {string|null} — Message to show in an alert when the button is clicked.
 */
function extractOtherDetails(templateDetails) {
    // Default return object with null values
    const defaultResult = {
        showAIReportGenerateBtn: null,
        buttonCaption: null,
        alertMessage: null,
    };

    if (!templateDetails?.tmpl_otherdetails) {
        return defaultResult;
    }

    try {
        const otherDetails = JSON.parse(templateDetails.tmpl_otherdetails);

        return {
            showAIReportGenerateBtn: otherDetails.aiReport ?? null,
            buttonCaption: otherDetails.button_caption ?? null,
            alertMessage: otherDetails.alert_message ?? null,
        };
    } catch (error) {
        console.error('extractOtherDetails: Failed to parse tmpl_otherdetails JSON:', error);
        return defaultResult;
    }
}

export default extractOtherDetails;
